import { useDispatch } from 'react-redux';
import {
  ApplicationDocument,
  BankingApplicationDocument,
  DO_APPLICATION_TYPE,
  formApplicationSections,
} from 'client-experience-toolbox';
import { deepCombine } from './utils';
import { useApplication } from 'hooks/useApplication';

type ApplicationType = Partial<ApplicationDocument> | Partial<BankingApplicationDocument>;

export const useUpdateApplication = (type: DO_APPLICATION_TYPE) => {
  const { application, section } = useApplication(type);
  const dispatch = useDispatch();
  const applicationSections = formApplicationSections(application?.type);
  const sectionName = applicationSections[section - 1] as keyof ApplicationDocument['sectionsCompletion'];

  const combineApplication = (
    application: ApplicationType,
    sectionName: string | number,
    field: string,
    value?: unknown,
  ) => {
    return deepCombine(
      {
        ...application,
        sectionsCompletion: {
          ...application.sectionsCompletion,
          [sectionName]: { completedAt: null },
        },
      },
      { [field]: value },
    );
  };

  const updateApplication = (field: string, value?: unknown) => {
    switch (type) {
      case DO_APPLICATION_TYPE.FACTORING:
        dispatch({
          type: 'SET_FACTORING_APPLICATION',
          factoringApplication: combineApplication(application, sectionName, field, value),
          sectionHasChanged: true,
        });
        break;
      case DO_APPLICATION_TYPE.BANKING:
        dispatch({
          type: 'SET_BANKING_APPLICATION',
          bankingApplication: combineApplication(application, sectionName, field, value),
          sectionHasChanged: true,
        });
        break;
      default:
        break;
    }
  };

  return updateApplication;
};
